import clsx from "clsx";
import { useDecoPreference } from "@/features/deco/DecoPreferenceProvider";
import type { DecoPreference } from "@/lib/decoPreference";

const OPTIONS: { value: DecoPreference; label: string; hint: string }[] = [
  { value: "full", label: "Voll", hint: "Alles mit dabei" },
  { value: "subtle", label: "Dezent", hint: "Nur das Wesentliche" },
  { value: "off", label: "Aus", hint: "Lieber ohne" },
];

export function DecoPreferenceControl() {
  const { preference, setPreference } = useDecoPreference();

  return (
    <section className="eh-account-section eh-deco-surprise">
      <h3 className="eh-account-section-title">Überraschung</h3>
      <p className="eh-deco-surprise__lead">
        Gerade ist etwas Besonderes in der App – so möchtest du es erleben.
      </p>
      <div className="eh-deco-pref-grid" role="radiogroup" aria-label="Überraschungseffekt">
        {OPTIONS.map((opt) => {
          const active = preference === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={active}
              className={clsx("eh-deco-pref-option", active && "eh-deco-pref-option--active")}
              onClick={() => setPreference(opt.value)}
            >
              <span className="eh-deco-pref-option__label">{opt.label}</span>
              <span className="eh-deco-pref-option__hint">{opt.hint}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
